document.addEventListener("DOMContentLoaded", function () {
  const accordionItems = document.querySelectorAll(".blog-accordion_items");

  accordionItems.forEach((item) => {
    const question = item.querySelector(".blog-accordion_question");
    const answer = item.querySelector(".blog-accordion_answer");
    const icon = item.querySelector(".blog-accordion_icon");

    // Start closed
    answer.style.maxHeight = "0px";

    question.addEventListener("click", () => {
      const isOpen = item.classList.contains("open");

      // Close other accordions (true accordion behavior)
      accordionItems.forEach((otherItem) => {
        if (otherItem !== item) {
          otherItem.classList.remove("open");
          const otherAnswer = otherItem.querySelector(".blog-accordion_answer");
          const otherIcon = otherItem.querySelector(".blog-accordion_icon");
          otherAnswer.style.maxHeight = "0px";
          otherIcon.textContent = "+";
        }
      });

      // Toggle current
      if (isOpen) {
        item.classList.remove("open");
        answer.style.maxHeight = "0px";
        icon.textContent = "+";
      } else {
        item.classList.add("open");
        answer.style.maxHeight = answer.scrollHeight + "px";
        icon.textContent = "–";
      }
    });
  });
});